var map = {
	"./angry.png": "f512",
	"./funny.png": "a714",
	"./like.png": "3d5e",
	"./love.png": "12e2",
	"./sad.png": "3bb2",
	"./small/angry.png": "f1bb",
	"./small/funny.png": "69c5",
	"./small/like.png": "22f6",
	"./small/love.png": "4e34",
	"./small/sad.png": "025d",
	"./small/wow.png": "d1d6",
	"./wow.png": "892e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0042";